import {ValueObject} from '@s-ui/domain'

export class SeoDataRequest extends ValueObject {
  /**
   * @param {Object} param
   * @param {String} param.culture
   * @param {Boolean} param.hasAttributes
   * @param {String} param.pageName
   * @param {Object} param.params
   * @param {String} param.params.articlePlainText
   * @param {Object} param.params.author
   * @param {Object} param.params.breadcrumb
   * @param {String} param.params.bodyType
   * @param {Array<Number>} param.params.bodyTypeIds
   * @param {String} param.params.canonical
   * @param {String} param.params.category
   * @param {String} param.params.categoryId
   * @param {String} param.params.cc
   * @param {String} param.params.city
   * @param {String} param.params.color
   * @param {String} param.params.commitmentMonths
   * @param {Array} param.params.cons
   * @param {String} param.params.dealerName
   * @param {String} param.params.dealerSlug
   * @param {Number} param.params.doors
   * @param {Number} param.params.entry
   * @param {String} param.params.fuelType
   * @param {Number} param.params.highPrice
   * @param {String} param.params.initDate
   * @param {Boolean} param.params.isCrawlableAndIndexable
   * @param {String} param.params.keywordSlug
   * @param {Number} param.params.kms
   * @param {Number} param.params.litres
   * @param {Number} param.params.lowPrice
   * @param {String} param.params.make
   * @param {Array} param.params.makes
   * @param {String} param.params.makeSlug
   * @param {String} param.params.model
   * @param {Array} param.params.models
   * @param {String} param.params.month
   * @param {Number} param.params.monthlySubscriptionFee
   * @param {String} param.params.nResults
   * @param {Number} param.params.offerCount
   * @param {String} param.params.offerType
   * @param {Number} param.params.offerTypeId
   * @param {String} param.params.page
   * @param {String} param.params.path
   * @param {String} param.params.price
   * @param {String} param.params.publicationDate
   * @param {Array} param.params.pros
   * @param {String} param.params.province
   * @param {Array} param.params.rating
   * @param {String} param.params.region
   * @param {String} param.params.regionId
   * @param {String} param.params.searchResults
   * @param {String} param.params.searchTerm
   * @param {String} param.params.seats
   * @param {String} param.params.subscriptionVehicleState
   * @param {String} param.params.tag
   * @param {Object} param.params.term
   * @param {String} param.params.title
   * @param {String} param.params.totalPages
   * @param {String} param.params.type
   * @param {String} param.params.updateDate
   * @param {String} param.params.vehicleId
   * @param {String} param.params.version
   * @param {String} param.params.versionId
   * @param {String} param.params.year
   * @param {String} param.params.adId
   * @param {Array<String>} param.params.photos
   * @param {Number} param.params.km
   * @param {Number} param.params.hp
   * @param {Number} param.params.fuelTankCapacity
   * @param {Number} param.params.consumptionAverage
   * @param {Number} param.params.emissions
   * @param {String} param.params.transmissionType
   * @param {Number} param.params.warrantyMonths
   * @param {Boolean} param.params.hasStock
   * @param {Boolean} param.params.hasWarranty
   * @param {Boolean} param.params.hasOfficialWarranty
   * @param {Object} param.params.sellerDealer
   * @param {Array} param.params.dealerReviews
   * @param {String} param.params.adDescription
   * @param {String} param.params.environmentalLabel
   * @param {String} param.params.environmentalLabelValue
   * @param {String} param.params.transmission
   * @param {Number} param.params.maxKms
   * @param {Array} param.preloadImages
   * @return {Promise<[error, data], Error>}
   **/

  static validate({culture, pageName, invalidSeoDataRequestError}) {
    if (!culture) throw invalidSeoDataRequestError('Culture is required')
    if (!pageName) throw invalidSeoDataRequestError('PageName is required')
  }

  get(paramName) {
    return this._params[paramName]
  }

  toCleanJSON() {
    return JSON.parse(JSON.stringify(this.toJSON()))
  }
}
